import React from 'react';
import { Page } from '../Page';
export function PageEssentialsDivider() {
  return <Page hideFooter variant="dark" data-id="element-1372" data-mp="hi7gzur7fuiv">
      <div className="flex flex-col h-full justify-center items-center text-center" data-id="element-1373" data-mp="hj8rny4b6f02">
        <p className="text-[10px] font-bold text-lightteal uppercase tracking-[0.25em] mb-4" data-id="element-1374" data-mp="cq78vf0zdvb7">
          Part Three
        </p>
        <h1 className="text-5xl font-serif text-white leading-tight mb-6" data-id="element-1375" data-mp="7rmgu2vvuhxu">
          The Essentials
        </h1>
        <div className="w-16 h-0.5 bg-tealslate" data-id="element-1376" data-mp="2qyhmtxi2usj" />
      </div>
    </Page>;
}